export default __webpack_public_path__ + "static/media/property_245.ba1d1fba.png";